<script setup>
let selected = defineModel('selected', { default: [], required: true, type: [Array, Number, String] })
</script>

<template>
    <multiselect
        v-bind="$attrs"
        v-on="$listeners"
        @open="expanded = true"
        @close="expanded = false"
        v-model="selected"
    >
        <span
            slot="caret"
            slot-scope="{ toggle }"
            @mousedown.prevent.stop="toggle"
            class="multiselect-caret"
        >
            <AnimatedCaret :expanded="expanded" />
        </span>
        <template v-for="(_, nameComp) in $slots" v-slot:[nameComp]="data">
            <slot :name="nameComp" v-bind="data"/>
        </template>
    </multiselect>
</template>

<script>

import Multiselect from 'vue-multiselect';
import AnimatedCaret from "@/components/AnimatedCaret.vue";

export default {
    inheritAttrs: false,
    components: { AnimatedCaret, Multiselect },
    data: function() {
        return {
            expanded: false
        };
    },
    computed: {
        multiselectSettings: function () {
            return {
                label: "id",
                trackBy: "id",
                placeholder: "",
                options: this.data,
                searchable: true,
                internalSearch: false,
                clearOnSelect: false,
                showLabels: false,
                preserveSearch: false,
                openDirection: "bottom",
                optionHeight: 60
            }
        },
    }
};
</script>

<style lang="scss"></style>
